/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.filter('_date', function(){
    return function(value, format) {
		if(_.isUndefined(format)) format='DD.MM.YYYY';
		return moment(value).format(format);
    };
});


app.filter('_dateWithHour', function(){
    return function(value) {
        
        return moment(value).format('DD.MM.YYYY, [godz.] HH:mm');
    
    };
});